export function parseTagPair(tagPair: string): { key: string; value: string } {
  const trimmed = tagPair.trim();

  // Preferred delimiter from the tagPair API format: "key: value".
  const spacedColonIdx = trimmed.indexOf(': ');
  if (spacedColonIdx >= 0) {
    return {
      key: trimmed.slice(0, spacedColonIdx).trim(),
      value: trimmed.slice(spacedColonIdx + 2).trim(),
    };
  }

  // Backward-compatible fallback if legacy "key:value" data appears.
  const colonIdx = trimmed.lastIndexOf(':');
  if (colonIdx < 0) {
    return { key: trimmed, value: '' };
  }

  return {
    key: trimmed.slice(0, colonIdx).trim(),
    value: trimmed.slice(colonIdx + 1).trim(),
  };
}

export function buildTagPairAutocompleteQuery(pattern: string, accounts?: string): string | null {
  const trimmedPattern = pattern.trim();
  if (!trimmedPattern) {
    return null;
  }

  const params = new URLSearchParams({ field: 'tagPair', pattern: trimmedPattern });
  if (accounts) params.set('accounts', accounts);
  return params.toString();
}

export function tagPairIdentityFromKeyValue(key: string, value: string): string {
  // tagPair matching is case-insensitive; normalize identity accordingly.
  return `${key.trim().toLocaleLowerCase()}\u0000${value.trim().toLocaleLowerCase()}`;
}

export function tagPairIdentityFromPair(tagPair: string): string {
  const { key, value } = parseTagPair(tagPair);
  return tagPairIdentityFromKeyValue(key, value);
}

/** useSearchFilter optionSelectionKey adapter — reads identity from option.id. */
export function tagPairIdentityFromOption(option: { id: string }): string {
  return tagPairIdentityFromPair(option.id);
}

/** Canonical display/id format aligned with the tagPair API: `key: value`. */
export function formatTagPairDisplay(key: string, value: string): string {
  const trimmedKey = key.trim();
  const trimmedValue = value.trim();
  if (!trimmedValue) {
    return trimmedKey;
  }
  return `${trimmedKey}: ${trimmedValue}`;
}
